import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquislider',
	templateUrl:'./JQUISliderPage.html',
	styles: [],
	styleUrls:['./JQUISliderPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUISliderPage
{
	mdContent_219 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.slider.JQUISlider;
\`\`\``;
	mdContent_220 = `\`\`\`java
new JQUISlider&lt;&gt;()
\`\`\``;
	mdContent_221 = `\`\`\`java
var slider = new JQUISlider<>();
slider.getOptions().setMin(0);
slider.getOptions().setMax(500);
slider.getOptions().setRange(true);
\`\`\``;
}
